import axios from 'axios';
import {get_headers, COUNT_SUB_ENTITIES_URL,
  LIST_SUB_ENTITIES_BY_PARENT_APPLICATION,} from '@/utils/constants/constants';
import alert_mixin from "@/utils/mixins/alert_mixin";

export default {
  name: "TrusteesView",
  mixins: [alert_mixin],

  data: () => ({
      trustees: [],
      is_loading_stats: false,
      is_loading_trustees: false,
      sub_entity_stats: {
        total: 0,
        is_active: 0
      }
    }),

    mounted() {
      this.fetch_sub_entity_stats();
      this.fetch_sub_entities();
    },

  methods: {
    role_badge_class(role) {
      switch (role) {
        case "Chairman":
          return "bg-light text-dark border";
        case "Founder Trustee":
          return "bg-warning-subtle text-warning border";
        case "Independent Trustee":
          return "bg-primary-subtle text-primary border";
        default:
          return "bg-secondary-subtle text-secondary border";
      }
    },

    fetch_sub_entity_stats() {
      const entity_profile_id = sessionStorage.getItem('entity_profile_id');
      if (!entity_profile_id) return;

      this.is_loading_stats = true;

      axios.get(COUNT_SUB_ENTITIES_URL, {
        headers: get_headers(),
        params: { entity_profile_id },
      })
        .then((response) => {
          if (response.data?.status === 'success') {
            this.sub_entity_stats.total = response.data.sub_entity_count || 0;
            this.sub_entity_stats.active = response.data.active_sub_entity_count || 0;
          }
        })
        .catch((err) => {
          this.show_error('Failed to load employee stats: ' + err.message);
        })
        .finally(() => {
          this.is_loading_stats = false;
        });
    },

    fetch_sub_entities() {
      const parent_application_id = sessionStorage.getItem('application_id');
      const entity_profile_id = Number(sessionStorage.getItem('entity_profile_id') || 0);

      if (!parent_application_id) return;

      this.is_loading_trustees = true;
      const params = { parent_application_id: Number(parent_application_id) };
      if (entity_profile_id > 0) params.entity_profile_id = entity_profile_id;

      axios.get(LIST_SUB_ENTITIES_BY_PARENT_APPLICATION, {
        headers: get_headers(),
        params,
      })
        .then(res => {
          const body = typeof res.data === 'string' ? JSON.parse(res.data) : res.data;

          if (body?.status !== 'success') {
            this.show_error(body?.message || 'Failed to load employees.');
            return;
          }

          const sub_entities = Array.isArray(body?.data)
            ? body.data : (body?.data?.children || []);

          // Map API response to trustee shape
          this.trustees = sub_entities.map((child) => {
            const form = Array.isArray(child.forms) ? child.forms[0] : null;
            const name = child.name || 'Unknown';
            const initials = name.split(' ').slice(0, 2).map(w => w[0]?.toUpperCase() || '').join('');

            return {
              id: child.id,
              initials,
              name,
              role: child.entity_type_name || '—',
              appointed: form?.date_created
                ? new Date(form.date_created).toLocaleDateString('en-ZA', {
                  day: 'numeric', month: 'long', year: 'numeric'
                }): '—',
            };
          });
        })
        .catch(err => {
          this.show_error('Failed to load employees: ' + (err.response?.data?.message || err.message));
        })
        .finally(() => {
          this.is_loading_trustees = false;
        });
    }
  },
};